import { createActionGroup, emptyProps } from '@ngrx/store';

import { ActionSource } from '../../state/action-sources';

export const LeaveConfirmationDialogActions = createActionGroup({
  source: ActionSource.LEAVE_CONFIRMATION_DIALOG,
  events: {
    'Discard Unsaved Changes Button Clicked': emptyProps(),
    'Save Changes Button Clicked': emptyProps(),
    },
  },
);
